







import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

export type ButtonType = "normal" | "confirm" | "deny";

@Component
export default class LCUButton extends Vue {
    @Prop({ default: false })
    disabled: boolean;

    @Prop({ default: "" })
    className: string;

    @Prop({ default: "normal" })
    type: ButtonType;
}
